import { useRoutes } from 'react-router-dom'
import { routes, onRouteBefore } from './router'
import { transformRoutes, setRouteBefore } from './router/utils'
import { App } from 'antd';
import en_US from 'antd/lib/locale/en_US';
import zh_CN from 'antd/lib/locale/zh_CN';
import { ConfigProvider } from 'antd';

let currentLanguage = localStorage.getItem('language') || navigator.language || navigator.userLanguage
if(currentLanguage.toLowerCase().includes('zh')){
  currentLanguage = 'zh'
}else{
  currentLanguage = 'en'
}
localStorage.setItem('language',currentLanguage)
const ExportApp =  ()=> {
  // 设置通用路由拦截
  setRouteBefore(onRouteBefore)
  // 将路由配置信息转为路由对象
  const elements = useRoutes(transformRoutes(routes))
  // const dispatch = useDispatch();
  // const language = useSelector((state) => state.languageSlice.language);
  // if(!language){
  //   dispatch(changeLanguage(currentLanguage))
  // }
  const languageEnum = {
    'zh':zh_CN,
    'en':en_US
  }
  const customBreakpoints = {
    small: 0,
    large: 992
  };
  const customTheme = {
    token: {
      // Seed Token，影响范围大
      colorPrimary: '#8B2938',
      borderRadius: 4,
      colorText:'#2A2A2A'
    },
  }
  return (
    <ConfigProvider theme={customTheme} locale={languageEnum[currentLanguage]} breakpoint={customBreakpoints}>
        <App>{elements}</App>
    </ConfigProvider>
  )
}
export default ExportApp;